import { FC, useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./CollectionMainDetail.scss";
import Header from "../../components/Header";
import { shallowEqual, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PageRoutes } from "../../utils/constants";
import Footer from "../../components/Footer";
import "../../assets/scss/common.scss";
import useAnalyticsEventTracker from "../../utils/useAnalyticsEventTracker";
import ReactGA from "react-ga4";
import NFTCard from "../../components/NFTCard";
import { CollectionListClass } from "../../utils/HelperClass/CommonClass";
import ApiService from "../../services/ApiService";

export const CollectionMainDetailPage: FC = () => {
	const navigate = useNavigate();
	const nftDetails = useSelector(
		({ nftData }) => nftData.trendingCollectionDetail,
		shallowEqual
	);
	const [TrendingCollection, setTrendingCollection] = useState<
		CollectionListClass[]
	>([]);

	useEffect(() => {
		if (!nftDetails?.name) {
			navigate(PageRoutes.Home);
		}
		async function getTrendingCollection() {
			const LandingSlider = await ApiService.GetNFTCollectionDetails(
				nftDetails?.collectionUrl || ""
			);
			setTrendingCollection(LandingSlider);
		}
		getTrendingCollection();
	}, []);

	return (
		<>
			<Header />
			<main className="main-content">
				<div className="inner-content">
					<section className="epic-main-wrapper">
						<Container>
							<Row className="epic-mobile-view">
								<Col lg={7}>
									<div className="epic-left-part-main">
										<div
											className="back-btn"
											onClick={() => {
												navigate(-1);
											}}
										>
											<span>
												<svg
													width="24"
													height="24"
													viewBox="0 0 24 24"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M14.9998 19.9201L8.47984 13.4001C7.70984 12.6301 7.70984 11.3701 8.47984 10.6001L14.9998 4.08008"
														stroke="white"
														stroke-width="1.5"
														stroke-miterlimit="10"
														stroke-linecap="round"
														stroke-linejoin="round"
													/>
												</svg>
											</span>
											Back
										</div>
										<h1 className="epic-title">{nftDetails?.name}</h1>
										<p className="epic-content">{nftDetails?.description}</p>
									</div>
									<Row>
										<Col md={4}>
											<div className="epic-box">
												<div className="epic-box-title">
													{(nftDetails.supply / 1000).toFixed(2)}K
												</div>
												<div className="epic-box-content">Item</div>
											</div>
										</Col>
										<Col md={4}>
											<div className="epic-box">
												<div className="epic-box-title">
													{(nftDetails.totalVolume / 1000).toFixed(2)}k
												</div>
												<div className="epic-box-content">Total vol.</div>
											</div>
										</Col>
										<Col md={4}>
											<div className="epic-box">
												<div className="epic-box-title">
													{nftDetails.floorPrice} SOL
												</div>
												<div className="epic-box-content">Floor</div>
											</div>
										</Col>
										<Col md={4}>
											<div className="epic-box">
												<div className="epic-box-title">-</div>
												<div className="epic-box-content">All Time High</div>
											</div>
										</Col>
										<Col md={4}>
											<div className="epic-box">
												<div className="epic-box-title">-</div>
												<div className="epic-box-content">Price Change</div>
											</div>
										</Col>
									</Row>
								</Col>
								<Col lg={{ span: 4, offset: 1 }}>
									<div className="mobile-back-btn">
										<span>
											<svg
												width="24"
												height="24"
												viewBox="0 0 24 24"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M14.9998 19.9201L8.47984 13.4001C7.70984 12.6301 7.70984 11.3701 8.47984 10.6001L14.9998 4.08008"
													stroke="white"
													stroke-width="1.5"
													stroke-miterlimit="10"
													stroke-linecap="round"
													stroke-linejoin="round"
												/>
											</svg>
										</span>
										Back
									</div>
									<div className="epic-right-side-image">
										<img src={nftDetails?.imageUrl} alt="Bear" />
									</div>
								</Col>
							</Row>

							<section className="landing-main-wrapper">
								<Container>
									<h2 className="collection-title">Trending Collection</h2>
									<Row>
										{TrendingCollection.length ? (
											TrendingCollection.map((hero, i) => {
												let item = { ...hero, page: "Trending-Page" };
												return (
													<NFTCard key={i} index={i} item={item}></NFTCard>
												);
											})
										) : (
											<Row>
												<h1 className="loading">Loading ...</h1>
											</Row>
										)}
									</Row>
								</Container>
							</section>
						</Container>
					</section>
				</div>
				<Footer></Footer>
			</main>
		</>
	);
};
